const ID_LOGO_FILTER = '#brand-filter--select';
const CLASS_LOGO_ITEM = '.logowall__filter--item';

const ID_PROJECT_FILTER = '#projectwall-filter--select';
const CLASS_PROJECT_ITEM = '.projectwall__filter--item';

let logoSelectEl: HTMLSelectElement;
let projectSelectEl: HTMLSelectElement;
let items: Array<Element>;
let type: string;

export default class Filter {

    constructor() {
        logoSelectEl = document.querySelector(ID_LOGO_FILTER);
        projectSelectEl = document.querySelector(ID_PROJECT_FILTER);
        if(logoSelectEl != null ){
            type = 'logo';
            this.render(logoSelectEl, type);
        }
        if(projectSelectEl != null) {
            type = 'project';
            this.render(projectSelectEl, type);
        }
    }

    render(selectEl: HTMLSelectElement, type: string) {
        selectEl.addEventListener('change', this.filterItems);
        switch (type) {
            case 'logo': items = Array.from(document.querySelectorAll(CLASS_LOGO_ITEM)); break;
            case 'project': items = Array.from(document.querySelectorAll(CLASS_PROJECT_ITEM)); break;
        }

    }

    filterItems(this: HTMLSelectElement){
        let selectedCategory = this.selectedOptions[0].getAttribute('data-category');
        items.forEach(item => {
          item.classList.remove('hide');
          if ((selectedCategory != item.getAttribute('data-category')) && selectedCategory != 'all') {
              item.classList.add('hide');
          }
        });
    }
}